import App from './news-articles.vue';
import { createApplication } from "../../helpers/app";

createApplication(App, 'news-articles');
